const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// The activation loading screen is mounted globally in MainAppContent: the
// activation target redirects off /ai, so mounting it here too would tear it
// down mid-redirect.

export const Route = createFileRoute("/_protected/ai")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});